import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {DashboardRoutingModule} from "./dashboard-routing.module";
import {HttpClientModule} from "@angular/common/http";
import {CrudService} from "./service/crud.service";



@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    DashboardRoutingModule,
    HttpClientModule,
  ],
  providers: [
    CrudService,
  ]
})
export class DashboardModule { }
